<script>
  import NavButton from "../../components/reusable/buttons/navbutton.svelte";
  import { screenStore } from "../../functions/stores";
  import Blog from "../blogs/blog.svelte";
  import FinalCall from "./finalCall.svelte";
  export let y;
  export let page = "";
</script>

<div
  style="max-width:100%;"
  class={(y > 0 ? "fixedNav  " : "") + "flex justify-between w-full bg-white"}
>
  <div class="py-1 sm:px-10 lg:px-20">
    <img
      style="cursor: pointer;  max-width:{$screenStore.width < 500
        ? '60%'
        : '100%'}"
      class={$screenStore.width < 500 ? "" : "w-48"}
      src="/images/1.png"
      alt=""
      on:keypress
      on:click={() => {
        location.href = "/";
      }}
    />
  </div>
  <div class="space-x-5 pr-10 sm:pt-10 px-20">
    {#if $screenStore.width < 500}
      <div class="min-[320px]:py-5">
        {#if page == "blogs"}
          <NavButton
            name={"Home"}
            active={false}
            click={() => {
              page = "home";
            }}
          />
        {:else}
          <div class="pt-5">
            <NavButton
              name={"Blogs"}
              active={false}
              click={() => {
                page = "blogs";
              }}
            />
          </div>
        {/if}
      </div>
    {:else if page == "blogs"}
      <NavButton
        name={"Back to home page"}
        active={false}
        click={() => {
          page = "home";
        }}
      />
    {:else}
      <NavButton
        name={"Blogs"}
        active={false}
        click={() => {
          page = "blogs";
        }}
      />
      <NavButton
        name={"What we offer"}
        active={false}
        click={() => {
          y = 1076;
        }}
      />
      <NavButton
        name={"About Us"}
        active={false}
        click={() => {
          y = 1737;
        }}
      />
    {/if}
  </div>
</div>
{#if y > 0}
  {#if $screenStore.width > 500}
    <div class="flex justify-between w-full bg-white">
      <div class="py-1 sm:px-10 px-20" />
      <div class="space-x-5 pr-10 py-10 px-20">
        <NavButton name={"Event"} click={() => {}} active={true} />
      </div>
    </div>
  {/if}
{/if}
{#if page == "home"}
  <div class="hero-image">
    {#if $screenStore.width > 500}
      <div class="wave">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          />
        </svg>
      </div>
    {/if}
  </div>

  <div class={$screenStore.width < 500 ? "smhero-text" : "hero-text"}>
    <h1
      style=""
      class="{$screenStore.width < 500
        ? 'smHeader'
        : 'lgheader'} font-bold text-slate-100"
    >
      Your peace of mind comes first
    </h1>
    <p>Speak to someone that understands where you are.</p>
    <div class="pt-10">
      <FinalCall />
    </div>
  </div>
{/if}

<style>
  .smLogo {
    max-width: 60%;
  }
  .lgheader {
    font-size: 50px;
    font-weight: bold;
  }
  .smHeader {
    font-size: 34px;
    font-weight: bold;
  }
  .fixedNav {
    position: fixed;
    z-index: 1;
    transition: all 0.3s ease-in-out;
  }
  .hero-image {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.223) 20%, #0f043175),
      url("/images/hero.jpg");
    filter: blur(0.5px);
    height: 70%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    border: none;
    box-shadow: none;
    padding-bottom: 10px;
  }

  .hero-text {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    z-index: 2;
  }
  .smhero-text {
    text-align: left;
    position: absolute;
    top: 50%;
    left: 40%;
    transform: translate(-50%, -50%);
    color: white;
    z-index: 2;
  }
  .wave {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    transform: rotate(180deg);
    border: 0%;
    box-shadow: none;
  }

  .wave svg {
    position: relative;
    display: block;
    width: calc(162% + 1.3px);
    height: 80px;
    transform: rotateY(180deg);
    border: 0%;
    box-shadow: none;
  }

  .wave .shape-fill {
    fill: #ffffff;
    border: none;
  }
</style>
